import { getArticleFromList } from "@pb/utils/onClick";
import { trackEvent } from "@pb/utils/tracking";
import { trackOptimizelyVanillaEvent } from "@pb/utils/optimizely";
import { AbEvents } from '../optimizely/optimizelyConstants';
import trackingConstants from './trackingConstants';
// tracking from where user arrived to PDP, usually part of click event, stores data temporarily into sessionstorage
// decoupled from AEM code (notifyClick on osa.js)
const trackOriginOfEvent = ({ ticketId, productCode, virtualCategory, origin, }) => {
    sessionStorage.setItem(`ticket_${productCode}`, ticketId);
    sessionStorage.setItem(`vc_${productCode}`, virtualCategory);
    sessionStorage.setItem(`origin_${productCode}`, origin);
    if (virtualCategory !== 'PRA1') {
        const categoryId = typeof utag_data !== 'undefined' ? utag_data.category_id : '';
        sessionStorage.setItem(`osa_area_${productCode}`, categoryId);
        sessionStorage.setItem(`osa_type_${productCode}`, 'SMALL');
    }
};
const handleClick = ({ event, productSet, modelInfo, praConfiguration, origin, }) => {
    const productDataSet = getArticleFromList(event, productSet);
    if (!productDataSet || !praConfiguration) {
        return;
    }
    const { TRACKING, SOURCE, ID, PANEL_ID, TRACKING_ID } = praConfiguration;
    const { articleCode, category, alternateColor, title, trackingInfo, brandName, origin: productOrigin, articleInfo, } = productDataSet;
    const productIndex = productSet.indexOf(productDataSet);
    const listName = TRACKING_ID || PANEL_ID || (ID && ID.toLowerCase());
    const finalOrigin = productOrigin || ((origin === null || origin === void 0 ? void 0 : origin.length) && origin) || SOURCE || '';
    const articleCodeAsString = `${articleCode || ''}`;
    // Only for A/B testing purposes
    // TODO: remove when iterative testing of component is completed. PXREC-2968
    const trackOptimizelyClickEvents = (praType, brandNameArg) => {
        const isMonkiBrand = !!(brandNameArg && brandNameArg === 'Monki');
        if (praType === 'SWG') {
            trackOptimizelyVanillaEvent(AbEvents.ON_CLICK_STYLE_WITH);
            if (isMonkiBrand)
                trackOptimizelyVanillaEvent(AbEvents.CLICK_PDP_PRA_STYLE_WITH_MONKI_ITEM);
        }
        else if (praType === 'PRA1') {
            trackOptimizelyVanillaEvent(AbEvents.ON_CLICK_OTHERS_ALSO_BOUGHT);
            if (isMonkiBrand)
                trackOptimizelyVanillaEvent(AbEvents.CLICK_PDP_PRA_OTHERS_ALSO_BOUGHT_MONKI_ITEM);
        }
        else if (praType === 'PRA2') {
            trackOptimizelyVanillaEvent(AbEvents.ON_CLICK_RELATED_ARTICLES);
        }
        if (isMonkiBrand)
            trackOptimizelyVanillaEvent(AbEvents.CLICK_PDP_PRA_MONKI_ITEM);
    };
    // Only for A/B testing purposes
    // TODO: remove when iterative testing of component is completed. PXREC-2968
    const trackOptimizelyATBEvents = (praType, articleCodeArg, brandNameArg) => {
        const isMonkiBrand = !!(brandNameArg && brandNameArg === 'Monki');
        let eventName;
        if (praType === 'SWG') {
            eventName = isMonkiBrand
                ? AbEvents.CLICK_PDP_ATB_PRA_STYLE_WITH_MONKI_ITEM // should also trigger monki item in general
                : AbEvents.ON_ATB_STYLE_WITH_CLICK;
        }
        else if (praType === 'PRA1') {
            eventName = isMonkiBrand
                ? AbEvents.CLICK_PDP_ATB_PRA_OTHER_ALSO_BOUGHT_MONKI_ITEM // should also trigger monki item in general
                : AbEvents.ON_ATB_OTHERS_ALSO_BOUGHT_CLICK;
        }
        else if (praType === 'PRA2') {
            eventName = AbEvents.ON_ATB_RELATED_ARTICLES_CLICK;
        }
        if (eventName) {
            const storageObject = {
                articleCode: articleCodeArg,
                event: eventName,
            };
            sessionStorage.setItem('relatedArticlesATBEvent', JSON.stringify(storageObject));
        }
    };
    const finalData = Object.assign(Object.assign({}, trackingConstants.CLICK), { product_list_name: [listName], product_id: [articleCodeAsString.length > 6 ? articleCodeAsString.substring(0, 7) : ''], product_article_id: [articleCodeAsString], product_name: [title ? `${title}`.toUpperCase() : ''], product_category: [category ? `${category}`.toUpperCase() : ''], product_color_code: [alternateColor ? `${alternateColor.code}` : ''], product_position: [`${productIndex + 1}`], product_brand: [brandName || ''], product_segment_type: articleInfo || modelInfo || '', imp_origin_system: [finalOrigin], event_type: (TRACKING === null || TRACKING === void 0 ? void 0 : TRACKING.CLICK) || '' });
    trackOptimizelyVanillaEvent(AbEvents.CLICK_SB_PRA_ITEM);
    trackEvent(finalData);
    if (trackingInfo === null || trackingInfo === void 0 ? void 0 : trackingInfo.ticketId) {
        trackOriginOfEvent({
            ticketId: trackingInfo.ticketId,
            productCode: articleCodeAsString,
            virtualCategory: listName,
            origin: finalOrigin,
        });
    }
    trackOptimizelyClickEvents(ID, brandName);
    trackOptimizelyATBEvents(ID, articleCode, brandName);
};
export default handleClick;
//# sourceMappingURL=handleClick.js.map